// TODO move to fe-mono
// curl https://crms.betgames.tv/api/v1/export/languages | jq | grep '"code"' | awk '{print $2}'
// Update together with date-fns library upgrades
export const customLocalesMapToDateFns = {
    en: 'en-GB',
    en_betway: 'en-GB',
    de_betway: 'de',
    fr_betway: 'fr',
    es_betway: 'es',
    no_betway: 'nn',
    pt_betway: 'pt',
    dk_betway: 'da',
    fi_betway: 'fi',
    ru_betway: 'ru',
    sv_betway: 'sv',
    it_betway: 'it',
    mt_betway: 'mt',
    en_kenya: 'en-GB',
    en_uganda: 'en-GB',
    ee: 'et', // Estonian
    dk: 'da', // Danish
    gr: 'el', // Greek
    ge: 'ka', // Georgian
    xr: 'ar', // Arabic
    bh: 'bg', // Bulgarian
    cg: 'fr', // French (Congo)
    xl: 'es', // Spanish (Latin America)
    il: 'he', // Hebrew (he-IL)
    zh: 'zh-TW', // Chinese
    zh_hant: 'zh-TW', // Chinese
    ar: 'ar-MA',
    ru2: 'ru',
    ru3: 'ru',
    lru: 'ru', // Lotto Russian
    fa: 'fa-IR', // Irish
    no: 'nn', // Norwegian
    'pt-br': 'pt-BR', // Portuguese
    tr2: 'tr', // Turkish
    pl2: 'pl', // Polish
    gr2: 'gr', // Greek
    'en-ng': 'en-GB',
};

let iFrameLocale: Locale;

export const setupDateFnsLocale = (
    locale: keyof typeof customLocalesMapToDateFns,
): Promise<void> => {
    const code = customLocalesMapToDateFns[locale] ?? locale;

    return import(`date-fns/locale/${code}/index.js`)
        .catch(() => import('date-fns/locale/en-GB/index.js'))
        .then((value) => {
            iFrameLocale = value.default;
        });
};

export const getDateFnsLocale = (): Locale => {
    if (!iFrameLocale) {
        throw new Error('You probably forgot to use "setupDateFnsLocale" and provide locale');
    }

    return iFrameLocale;
};
